import { ListItemIcon } from '@mui/material';
import { 
    TextFields as TextIcon,
    Rtt as TextareaIcon,
    Event as DateIcon,
    Schedule as DatetimeIcon,
    CheckBoxOutlined as CheckboxIcon,
    ToggleOn as SwitchIcon,
    List as SelectIcon,
    PlaylistAdd as SelectmultipleIcon,
    RadioButtonChecked as RadiosIcon,
    LibraryAddCheckOutlined as CheckboxesIcon,
    InfoOutlined as InfoIcon,
} from '@mui/icons-material';

const iconMapping = {
    text: TextIcon,
    textarea: TextareaIcon,
    date: DateIcon,
    datetime: DatetimeIcon,
    checkbox: CheckboxIcon,
    switch: SwitchIcon,
    select: SelectIcon,
    selectmultiple: SelectmultipleIcon,
    radios: RadiosIcon,
    checkboxes: CheckboxesIcon,
    info: InfoIcon,
};

const FieldIcon = ({ type }) => {
    const Icon = iconMapping[type] || TextIcon;
    
    return (
        <ListItemIcon sx={{ color: 'primary.main' }}>
            <Icon />
        </ListItemIcon>
    );
};

export default FieldIcon;
